module.exports = __webpack_public_path__ + "static/media/graphic_stories_header.b33b5edd.png";